import {getQuestions} from '../services/workflow';

export const actions = {
  FETCH_PENDING: 'QUESTION::FETCH_PENDING',
  FETCH_FULFILLED: 'QUESTION::FETCH_FULFILLED',
  FETCH_REJECTED: 'QUESTION::FETCH_REJECTED',
};

export function fetchQuestions(inputHandle, inputValue) {
  return dispatch => {
    dispatch({type: actions.FETCH_PENDING});

    return getQuestions(inputHandle, inputValue)
      .then((questions = []) => {
        questions.forEach(question => {
          dispatch({type: actions.FETCH_FULFILLED, payload: {question}});
        });

        return questions;
      })
      .catch(err => {
        dispatch({
          type: actions.FETCH_REJECTED,
          payload: {
            error: {
              title: 'Unable to fetch question',
              message: err.message,
            },
          },
        });
      });
  };
}
